import type {
	ApiGetPermissionsTreeResponse,
	FeatureInformation,
} from '@repo/api-codegen';
import { toPairs } from 'lodash-es';

export function toFeatureGroups(
	permissionsTree: ApiGetPermissionsTreeResponse
): {
	group: string;
	features: Array<FeatureInformation>;
}[] {
	return toPairs(permissionsTree).reduce(
		(acc, [feature, featureInfo]) => {
			const existingGroup = acc.find((g) => g.group === featureInfo.group);
			if (existingGroup) {
				existingGroup.features.push(featureInfo);
			} else {
				acc.push({
					group: featureInfo.group,
					features: [featureInfo],
				});
			}
			return acc;
		},
		[] as Array<{
			group: string;
			features: Array<FeatureInformation>;
		}>
	);
}
